// extracted by mini-css-extract-plugin
export default {"user_badge":"userbadge_user_badge__9jke9","user_icon":"userbadge_user_icon__fD8fJ"};